export default __webpack_public_path__ + "static/media/failure_icon.88725b0a.svg";